import React from "react"
import { useRouteLoaderData, useParams } from "react-router-dom"
import {
  Grid,
  Box,
  TableContainer,
  Table,
  Thead,
  Th,
  Tr,
  Td,
  Tbody,
  Alert,
  Flex,
} from "@chakra-ui/react"
import { Schemas } from "../lib/store"

export default function SchemaDetail() {
  const user = useRouteLoaderData("auth")
  const [schemas] = Schemas.useState()
  const { schemaId } = useParams()
  // Find the selected schema
  const schema = React.useMemo(() => schemas[schemaId], [schemas, schemaId])
  // Get the schema properties
  const properties = React.useMemo(
    () => schema?.schema?.properties || {},
    [schema],
  )
  // Render table rows
  const rows = React.useMemo(() => {
    const entries = Object.entries(properties)
    if (!entries.length) return []
    return entries.map(([name, value]) => {
      let allowed = value.enum || ["Any"]
      allowed = allowed.map((v) => (
        <Grid key={v} xs={2}>
          {v}
        </Grid>
      ))
      allowed = allowed ? <Grid columns={10}>{allowed}</Grid> : null

      let constraints = []
      if (value?.maximum) constraints.push(`maximum: ${value.maximum}`)
      if (value?.minimum) constraints.push(`minimum: ${value.minimum}`)
      if (value?.precision) constraints.push(`precision: ${value.precision}`)
      if (value?.format) constraints.push(`format: ${value.format}`)
      constraints = constraints.map((c) => (
        <Grid key={c} xs={2}>
          {c}
        </Grid>
      ))

      const required = schema?.schema?.required?.includes(name) ? "Yes" : "No"

      return (
        <Tr
          key={name}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <Td>{name}</Td>
          <Td>{value.type}</Td>
          <Td>{required}</Td>
          <Td>{allowed}</Td>
          <Td>{constraints}</Td>
        </Tr>
      )
    })
  }, [schema, properties])

  // Render nothing if we don't have a user
  if (!user) return null
  // Render a not found if we couldn't find a schema in state
  if (!schema)
    return (
      <Box>
        <Alert status="error">Schema not found</Alert>
      </Box>
    )

  return (
    <Flex direction="column" flexGrow={1} minHeight={0}>
      <Box m="0em 0em 0.5em 0em">{schema.description}</Box>
      <TableContainer
        mt="1em"
        borderRadius="0.5em"
        boxShadow="lg"
        overflowY="auto"
      >
        <Table>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Type</Th>
              <Th>Required</Th>
              <Th>Allowed Values</Th>
              <Th>Constraints</Th>
            </Tr>
          </Thead>
          <Tbody>{rows}</Tbody>
        </Table>
      </TableContainer>
    </Flex>
  )
}
